import { IGSTOfferRawData, ISegmentOffer, OfferDetail, TransactionRange } from './type';

export const hydrateFormData = (data: ISegmentOffer): IGSTOfferRawData => {
	const hydratedData: IGSTOfferRawData = { transactionRange: [] as TransactionRange[] } as IGSTOfferRawData;
	hydratedData.segmentName = data.segmentName;
	hydratedData.segmentExclusive = data.segmentExclusive.join(',') || '';
	hydratedData.bucketName = data.bucketName;
	hydratedData.isActive = data.isActive;
	hydratedData.limitBasedOffer = data.offerDetail.limitBasedOffer;
	hydratedData.transactionRange =
		data?.offerDetail?.transactionRange?.map((currentOffer: any) => {
			const filteredOffer: any = {};
			filteredOffer.start = currentOffer.range.start?.toLocaleString('en-IN');
			filteredOffer.end = currentOffer.range?.end?.toLocaleString('en-IN');
			filteredOffer.offerPercentage = currentOffer.offerPercentage?.toLocaleString('en-IN') || '0';
			filteredOffer.cashbackPercentage = currentOffer.cashbackPercentage?.toLocaleString('en-IN') || '0';
			filteredOffer.bonusPercentage = currentOffer.bonusPercentage?.toLocaleString('en-IN') || '0';
			return filteredOffer;
		}) || [];
	return hydratedData;
};

export const dehydrateFormData = (data: IGSTOfferRawData): ISegmentOffer => {
	const gstOffer: ISegmentOffer = { offerDetail: {} as OfferDetail } as ISegmentOffer;
	gstOffer.segmentName = data.segmentName;
	gstOffer.segmentType = data.segmentType;
	gstOffer.bucketName = data.bucketName;
	gstOffer.isActive = data.isActive;
	gstOffer.segmentExclusive = data.segmentExclusive.split(',') || [];
	gstOffer.offerDetail.id = '1';
	gstOffer.offerDetail.limitBasedOffer = data.limitBasedOffer;
	gstOffer.offerDetail.transactionRange = data.transactionRange.map((currentDetail: any) => {
		const filteredOffer: any = {};
		filteredOffer.range = { start: +currentDetail.start?.replace(/,/g, '') };
		if (+currentDetail.end?.replace(/,/g, '')) filteredOffer.range.end = +currentDetail.end?.replace(/,/g, '');
		filteredOffer.offerPercentage = currentDetail.offerPercentage;
		filteredOffer.cashbackPercentage = currentDetail.cashbackPercentage;
		filteredOffer.bonusPercentage = currentDetail.bonusPercentage;
		return filteredOffer;
	});
	return gstOffer;
};
